import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EBDashboardBenefitDetailsRequest } from '../../models/eb-dashboard-member-benefit-details-request-vm';

@Injectable({
  providedIn: 'root'
})

export class EmployeeDashboardService {

  routePrefix = '/api/eb-dashboard';
  requestTokenKey = 'requestToken';
  requestToken: string;
  constructor(private http: HttpClient) { }

  getByEmail(): Observable<any>{
    return this.http.get(this.routePrefix + '/enrol-landing-page-details');
  }

  getAllActiveMembersByEnrolId(): Observable<any> {
    return this.http.get(this.routePrefix + '/member-benefit/active-members')
  }

  getAllActiveEnrolProductsByEnrolId(): Observable<any> {
    return this.http.get(this.routePrefix + '/member-benefit/active-enrol-products')
  }

  getAllActiveDependentProductsByEnrolDependentId(enrolDependentId: number): Observable<any> {
    return this.http.get(this.routePrefix + '/member-benefit/active-dependent-products/' + enrolDependentId)
  }

  getAllActiveMemberProductBenefitDetails(requestData: EBDashboardBenefitDetailsRequest): Observable<any> {
    return this.http.get(this.routePrefix + '/member-benefit/active-member-product-benefits?'
                                           + 'claimTypePrefixNumber=' + requestData.claimTypePrefixNumber
                                           + '&enrolLatestSalary=' + requestData.enrolLatestSalary
                                           + '&groupPolicyClusterProductId=' + requestData.groupPolicyClusterProductId
                                           + '&groupPolicyId=' + requestData.groupPolicyId
                                           + '&isEnrol=' + requestData.isEnrol
                                           + '&memberProductId=' +requestData.memberProductId
                                           + '&memberProductCode=' +requestData.memberProductCode)
  }

  getRequestTokenHeader(): HttpHeaders {
    this.requestToken = sessionStorage.getItem(this.requestTokenKey);
    return new HttpHeaders().set(this.requestTokenKey, this.requestToken);
  }

  clearRequestToken() {
    sessionStorage.removeItem(this.requestTokenKey);
  }

  generateOtp(
    groupPolicyNo: string,
    birthYear: number,
    certificateNo: string,
    recaptcha: string,
  ): Observable<any> {
    const body = {
      groupPolicyNumber: groupPolicyNo.toString(),
      birthYear: birthYear,
      certificateNumber: certificateNo.toString(),
      recaptcha: recaptcha,
    };
    return this.http.post(this.routePrefix+ "/generate-otp", body);
  }

  otpValidation(otp: string, enrolId: number): Observable<any> {
    const body = {
      otp: otp,
      enrolId: enrolId
    };
    return this.http.post(this.routePrefix+ "/validate-otp", body, { headers: this.getRequestTokenHeader() });
  }
}
